import React from "react";
import { Row, Container } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import '../css/table.css'
import useTables from "../hooks/useTables";  
import TableCard from "../components/TableCard";
import TableSearchInput from "../components/TableSearchInput"; // Kereső input
import TableToggleButton from "../components/TableToggleButton"; // Kinyitás/Becsukás gomb
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useSelector } from "react-redux";

export default () => {
  const navigate = useNavigate();
  const tasks = useSelector(state => state.tasks)

  const {
    keyword,
    setKeyword,
    tableStates,
    allOpen,
    toggleTableState,
    toggleAllTablesState,
    filteredTables,
  } = useTables(); // hooks

  const redirect = (e, url) => {
    e.preventDefault();
    e.stopPropagation();
    navigate(url);
  };

  return (
    <div>
      <div className={"page-head my-2 d-flex"}>
        <h3 className="title"><strong>Táblacsoportok</strong></h3>
        <Link to={"/"} className={"btn button"}><FontAwesomeIcon icon="fa-solid fa-chevron-left" />{" Vissza"} </Link>
      </div>
      <TableSearchInput keyword={keyword} setKeyword={setKeyword} />
      
      <Container className="openclose-btn-container mb-3">
        <TableToggleButton allOpen={allOpen} toggleAllTablesState={toggleAllTablesState} />
      </Container>

      <Row className="tables-container">
        {filteredTables && filteredTables.map((table) => (
          <TableCard 
            key={table.table_id} 
            table={table} 
            isOpen={tableStates[table.table_id] !== false} 
            toggleTableState={toggleTableState} 
            redirect={redirect}
            taskCount={tasks.filter(task => task.table_id.includes(table.table_id)).length}
          />
        ))}
      </Row> 
    </div>
  );
};
